angular.module('cakeapp')

.factory('srvService', function($q, $localStorage, applicationSettings , configHandler) {
    'use strict';
    return {
        getVmrDetails: function(uri) {
            var uriComponents = uri.split('@');
            var domain = uriComponents[1];
            
            var deferred = $q.defer();
            deferred.resolve([configHandler.getConfig().server_address, $localStorage.serverAddress]);
            return deferred.promise;
        }
    };
});
